<v-public-bottom-gradient-wrapper>
  <div
    class="flex flex-col gap-10 w-[90vw] md:min-w-sm md:w-xl relative max-w-[480px]">
    <v-public-logo-header
      [header]="'onboarding.organization.header' | transloco"
      [subheader]="
        'onboarding.organization.aboutYou' | transloco
      "></v-public-logo-header>

    <v-card padding="lg" variant="glass-v2">
      <div slot="body">
        @if (!isSubmitting) {
          <form
            [formGroup]="newOrgForm"
            class="flex flex-col space-y-4 pb-6"
            (submit)="onFormSubmit()">
            <v-input-field
              label="{{ 'onboarding.organization.name.label' | transloco }}"
              fControlName="orgName">
              <v-input-v2
                type="text"
                fControlName="orgName"
                placeholder="{{
                  'onboarding.organization.name.placeholder' | transloco
                }}"
                testId="org-name-input"></v-input-v2>
            </v-input-field>

            <!-- Terms and conditions -->
            <div class="flex items-center text-sm mt-8">
              <p-checkbox
                inputId="acceptTerms"
                formControlName="acceptTerms"
                [binary]="true"></p-checkbox>
              <label for="acceptTerms" class="ml-4 leading-5">
                {{ 'onboarding.organization.terms.start' | transloco }}
                <a
                  class="text-subtle underline font-medium"
                  href="https://incidite.com/legal/terms-and-conditions"
                  target="_blank">
                  {{ 'onboarding.organization.terms.termsLink' | transloco }}
                </a>
                {{ 'onboarding.organization.terms.middle' | transloco }}
                <a
                  class="text-subtle underline font-medium"
                  href="https://incidite.com/legal/privacy-policy"
                  target="_blank"
                  >{{
                    'onboarding.organization.terms.privacyPolicyLink'
                      | transloco
                  }}
                </a>
                {{ 'onboarding.organization.terms.end' | transloco }}
              </label>
            </div>
          </form>
        }

        @if (isSubmitting) {
          <div class="flex flex-col items-center justify-center py-8 space-y-4">
            <i
              class="pi pi-spin pi-spinner text-4xl! text-primary-inverted mb-4"></i>
            <div class="flex flex-col items-center space-y-2">
              <p class="text-2xl text-gray-300 font-semibold mb-4">
                {{
                  'onboarding.organization.creatingProcessSpinner.first'
                    | transloco
                }}
              </p>
              <p
                class="text-md text-gray-400 opacity-0 animate-fade-up animate-once animate-duration-500 animate-delay-1000 animate-ease-in-out text-center">
                {{
                  'onboarding.organization.creatingProcessSpinner.second'
                    | transloco
                }}
              </p>
              <p
                class="text-md text-gray-400 opacity-0 animate-fade-up animate-once animate-duration-500 animate-delay-2250 animate-ease-in-out text-center">
                {{
                  'onboarding.organization.creatingProcessSpinner.third'
                    | transloco
                }}
              </p>
              <p
                class="text-md text-gray-400 opacity-0 animate-fade-up animate-once animate-duration-500 animate-delay-3500 animate-ease-in-out text-center">
                {{
                  'onboarding.organization.creatingProcessSpinner.fourth'
                    | transloco
                }}
              </p>
            </div>
          </div>
        }

        @if (createOrganizationError) {
          <p-message
            severity="error"
            styleClass="w-full mt-4"
            [text]="createOrganizationError"></p-message>
        }

        @if (!isSubmitting) {
          <v-button-v2
            (press)="onFormSubmit()"
            icon="pi pi-plus"
            [disabled]="!newOrgForm.valid"
            [fullWidth]="true"
            >
            {{ 'pages.createOrganization.createOrgBtn' | transloco }}
          </v-button-v2>
        }
      </div>
    </v-card>
  </div>
</v-public-bottom-gradient-wrapper>
